export { default } from 'features/promotions/routes/quest-terms-route';
